import {
  GetOrderDetailData,
} from "services/interface";
import {
  Form,
  Modal,
} from "antd";

import styled from "@emotion/styled";
import RefundOrderDialog from "../RefundOrderDialog";
import RefundPaymentDialog from "../RefundPaymentDialog";

interface ModalRefundPaymentProps {
  item: GetOrderDetailData | undefined;
  open: boolean;
  onClose: () => void;
  refetchData: () => void;
  refund_process: string;
}

const ModalRefundPayment = ({
  item,
  onClose,
  open,
  refetchData,
  refund_process
}: ModalRefundPaymentProps) => {
  const [formRefund] = Form.useForm();
  return (
    <>
      {item && (
        <div>
          <Modal
            title={`การคืนเงินของคำสั่งสั่งซื้อ ${refund_process === 'overpay' ? 'ที่โอนเงินเกิน': 'ที่ยกเลิก'}: ${item.order_code}`}
            open={open}
            maskClosable={false}
            onCancel={() => {
              onClose();
              formRefund.resetFields();
            }}
            style={{ top: 20 }}
            cancelText="ปิด" okText="ยืนยันการคืนเงิน"
            okButtonProps={{
              style: { backgroundColor: "#ff4d4f", borderColor: "#ff4d4f", color: "white" },
            }}
            onOk={() => {
              formRefund.submit();
            }}
          >
            <WrapperAll>
              <RefundPaymentDialog refund_process={refund_process} form={formRefund} item={item} onClose={onClose} refetchData={refetchData} />
            </WrapperAll>
          </Modal>
        </div>
      )}
    </>
  );
};

export default ModalRefundPayment;

const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
`;
